var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMaleAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5882 19.0588V25.6199C32.5882 31.3937 27.8234 36.1177 22 36.1177C16.1765 36.1177 11.4117 31.3937 11.4117 25.6199V19.0588",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0981 26.1177H34.6961C36.125 26.1177 37.2941 24.9412 37.2941 23.5033V22.1961C37.2941 20.7582 36.125 19.5817 34.6961 19.5817H26.9019C24.044 19.5817 21.7058 17.2288 21.7058 14.353C21.7058 17.2288 19.3674 19.5817 16.5096 19.5817H8.7157C7.28696 19.5817 6.11768 20.7584 6.11768 22.1961V23.5033C6.11768 24.9412 7.28679 26.1177 8.7157 26.1177H11.3137",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05884 19.0588V14.7941C9.05884 7.75735 14.8824 2 22 2C29.1177 2 34.9412 7.75735 34.9412 14.7941V19.0588",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2632 34.9412L16.6364 38.8561L8.16206 41.948C4.97747 43.1099 2 46.0205 2 49.4213V52H42V49.4213C42 46.0217 39.0225 43.1101 35.8379 41.9481L27.3636 38.8563L26.7366 34.9413",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2941 39.0588C27.2941 41.9827 24.9238 44.353 22 44.353C19.0761 44.353 16.7059 41.9827 16.7059 39.0588",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaleAlt);
export default __webpack_public_path__ + "static/media/icon-male-alt.f3bc451a4f5e6e0c90d296134f26d275.svg";
export { ForwardRef as ReactComponent };